function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.04492 1.22266C5.21094 0.857422 5.57617 0.625 5.97461 0.625H9.99219C10.3906 0.625 10.7559 0.857422 10.9219 1.22266L11.1875 1.6875H14.375C14.9395 1.6875 15.4375 2.18555 15.4375 2.75C15.4375 3.34766 14.9395 3.8125 14.375 3.8125H1.625C1.02734 3.8125 0.5625 3.34766 0.5625 2.75C0.5625 2.18555 1.02734 1.6875 1.625 1.6875H4.8125L5.04492 1.22266ZM1.5918 4.875H14.375V15.5C14.375 16.6953 13.4121 17.625 12.25 17.625H3.7168C2.55469 17.625 1.5918 16.6953 1.5918 15.5V4.875ZM4.24805 7.53125V14.9688C4.24805 15.2676 4.51367 15.5 4.7793 15.5C5.07812 15.5 5.31055 15.2676 5.31055 14.9688V7.53125C5.31055 7.26562 5.07812 7 4.7793 7C4.51367 7 4.24805 7.26562 4.24805 7.53125ZM7.43555 7.53125V14.9688C7.43555 15.2676 7.70117 15.5 7.9668 15.5C8.26562 15.5 8.53125 15.2676 8.53125 14.9688V7.53125C8.53125 7.26562 8.26562 7 7.9668 7C7.70117 7 7.43555 7.26562 7.43555 7.53125ZM10.6562 7.53125V14.9688C10.6562 15.2676 10.8887 15.5 11.1875 15.5C11.4531 15.5 11.7188 15.2676 11.7188 14.9688V7.53125C11.7188 7.26562 11.4531 7 11.1875 7C10.8887 7 10.6562 7.26562 10.6562 7.53125Z",
  fill: "#EC2B00"
});

const SvgTrashHover = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTrashHover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trashHover.08cec816.svg";
export { ForwardRef as ReactComponent };